import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'
import { ref, onMounted } from 'vue'

interface DataItem {
  name: string
  phone?: string
}

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneListComponent',
  props: {
    label: { type: String, required: true },
    data: { type: Array, required: true },
    index: { type: Number, required: true }
  },
  emits: ['setRef'],
  setup(__props: any, { emit }) {

const props = __props as {
  label: string
  data: DataItem[]
  index: number
};



const icon = {
  phone: Icons.CALL
}

// EMITS


// REFS
const phoneListRef = ref<HTMLElement | null>(null)

// HOOKS
onMounted(() => {
  if (phoneListRef.value) {
    emit('setRef', phoneListRef.value, props.index)
  }
})

return { __sfc: true,props, icon, emit, phoneListRef }
}

})